// src/i18n/pl/views/dominioPropio.js
//
// Guía que ve el anfitrión para apuntar su dominio a la web del constructor.
// Base en inglés del fichero; el original con las notas largas está en es/.
//
// Marcadores que rellena la pantalla:
//   {dominio} {destino} {nombre} {tipo} {valor} {encontrado} {actual} {sitio}
//   {panel} {panelCorto}

export const dominioPropio = {
  cabecera: {
    titulo: "Podłącz własną domenę",
    subtitulo:
      "Strona działa teraz pod adresem {actual}. Po zakończeniu będzie dostępna pod Pana/Pani zwykłym adresem.",
    duracion: "Dziesięć minut Pana/Pani czasu. Resztę internet zrobi sam.",
  },

  pasos: {
    uno: "Domena",
    dos: "Dwa wpisy w {panelCorto}",
    tres: "Sprawdzenie",
    unoDetalle: "Wpisanie adresu, który ma być używany",
    dosDetalle: "Skopiowanie dwóch linii do panelu domeny",
    tresDetalle: "Sprawdzamy, czy wszystko jest na miejscu",
    indicador: "Krok {paso} z 3",
  },

  // ── Paso 1: escribir el dominio ────────────────────────────────────────────
  paso1: {
    titulo: "Jaki adres ma mieć Pana/Pani strona?",
    descripcion:
      "Proszę wpisać domenę, którą już Pan/Pani posiada. Nie sprzedajemy domen: tutaj podłącza się domenę, która już jest Pana/Pani własnością.",
    etiqueta: "Domena",
    marcador: "mojadomena.pl",
    ayuda: "Proszę wpisać ją tak, jak jest, bez „https://” i bez ukośnika na końcu.",

    formaTitulo: "A jak ma brzmieć?",
    formaRaiz: {
      titulo: "mojadomena.pl",
      descripcion: "Krótki adres, bez niczego z przodu. To najczęstszy wybór.",
    },
    formaWww: {
      titulo: "www.mojadomena.pl",
      descripcion: "Klasyczny wariant, z „www” z przodu.",
    },
    formaSubdominio: {
      titulo: "rezerwacje.mojadomena.pl",
      descripcion:
        "Osobny adres, dzięki czemu nie trzeba ruszać strony, która już działa pod adresem {dominio}.",
    },
    subdominioEtiqueta: "Słowo, które stoi z przodu",
    subdominioMarcador: "rezerwacje",
    subdominioAyuda: "Tylko to słowo. Resztę dopiszemy my.",

    avisoWebExistente: {
      titulo: "Czy pod tym adresem jest już jakaś strona?",
      texto:
        "Jeśli {dominio} pokazuje dziś inną stronę, przestanie się ona wyświetlać, a jej miejsce zajmie ta. Jeśli woli Pan/Pani ją zachować, proszę użyć osobnego adresu, na przykład rezerwacje.{dominio}.",
    },

    boton: "Kontynuuj",
    botonComprobando: "Sprawdzanie domeny…",
  },

  // ── Dónde tiene el dominio ─────────────────────────────────────────────────
  proveedor: {
    pregunta: "Gdzie kupił(a) Pan/Pani domenę {dominio} lub gdzie nią zarządza?",
    ayuda:
      "To firma, której co roku płaci Pan/Pani za odnowienie. Jeśli nie pamięta Pan/Pani, proszę poszukać w poczcie ostatniej faktury za domenę.",
    cloudflare: "Cloudflare",
    cloudflareDetalle: "Pełna instrukcja, ekran po ekranie",
    otro: "Inna firma",
    otroDetalle: "GoDaddy, IONOS, Namecheap, OVH…",
    otroTexto:
      "Wpisy są dokładnie takie same. Zmienia się tylko położenie przycisku. Proszę poszukać w panelu czegoś, co nazywa się „DNS”, „Strefa DNS” albo „Zarządzanie DNS”, i skopiować tam linie z powyższej tabeli, jedna po drugiej.",
    noLoSe: "Nie wiem",
    noLoSeTexto:
      "Proszę napisać do nas, podając domenę, a powiemy, gdzie jest i co trzeba zmienić.",
  },

  // ── Paso 2: los registros ──────────────────────────────────────────────────
  paso2: {
    titulo: "Teraz trzeba powiedzieć domenie, gdzie jest Pana/Pani strona",
    descripcion:
      "Domena to nazwa. Sama z siebie nigdzie nie prowadzi: ktoś musi zapisać w zeszycie, że ta nazwa należy do naszego serwera. Ten zeszyt nazywa się DNS i znajduje się w panelu domeny.",

    queEsUnRegistro: {
      titulo: "Co dokładnie trzeba zrobić",
      texto:
        "Doda Pan/Pani do tego zeszytu jedną linię. Tylko jedną. Ma ona trzy pola: jak się nazywa, dokąd prowadzi i czy przechodzi przez filtr. Nic więcej.",
      textoOtro:
        "Doda Pan/Pani do tego zeszytu kilka linii. Każda ma dwa pola: jak się nazywa i dokąd prowadzi. Nic więcej.",
    },

    copiaTitulo: "Proszę skopiować te dane dokładnie tak, jak wyglądają",
    copiaAyuda:
      "Najlepiej użyć przycisków kopiowania. Jedna spacja za dużo albo jedna zła litera i nic nie zadziała.",

    tabla: {
      tipo: "Typ",
      nombre: "Nazwa",
      destino: "Cel",
      contenido: "Zawartość",
      proxy: "Status proxy",
      ttl: "TTL",
      valorProxy: "DNS only (szara chmurka)",
      valorTtl: "Auto",
    },

    copiar: "Kopiuj",
    copiado: "Skopiowano",
    copiarTodo: "Kopiuj dane",

    tipos: {
      cnameTitulo: "CNAME",
      cnameTexto:
        "To przekierowanie: mówi, że Pana/Pani domena jest serwowana pod adresem {destino}. Jeśli kiedyś zmienimy serwery, nie trzeba będzie niczego ruszać.",
      txtTitulo: "TXT",
      txtTexto:
        "To podpisana notatka. Nigdzie nie prowadzi: tylko potwierdza, że domena należy do Pana/Pani. Można ją usunąć, gdy strona zacznie działać, ale najprościej zostawić ją na miejscu.",
    },

    nombreTitulo: "Co wpisać w polu „Nazwa”",
    nombreRaiz:
      "Dla krótkiej domeny ({dominio}) proszę wpisać małpę: @. W zeszycie DNS małpa oznacza „samą domenę, bez niczego z przodu”. Nie należy wpisywać całego {dominio}.",
    nombreWww: "Dla www.{dominio} proszę wpisać tylko: www",
    nombreSubdominio:
      "Dla {nombre}.{dominio} proszę wpisać tylko słowo z przodu: {nombre}",
    nombreAviso:
      "W Cloudflare wpisuje się tylko tę część. Resztę, czyli „.{dominio}”, dopisuje on sam i pokazuje pod polem.",
    nombreAvisoOtro:
      "Niemal w każdym panelu wpisuje się tylko tę część, a „.{dominio}” dopisuje się samo. Jeśli Pana/Pani panel prosi o pełną nazwę, proszę wpisać {nombre}.{dominio}.",
    nombreAvisoOtroRaiz:
      "Jeśli panel nie przyjmuje „@”, proszę zostawić nazwę pustą: w wielu z nich oznacza to to samo, czyli domenę bez niczego z przodu.",

    volver: "Zrobione, wracam do WACheckin",
    ayudaEnviar: "Wyślij mi te dane e-mailem",
    ayudaEnviarTexto:
      "Jeśli ma to zrobić Pana/Pani informatyk albo osoba, która stworzyła stronę, wyślemy instrukcję na Pana/Pani adres e-mail, żeby można ją było przekazać dalej.",
  },

  // ── Cloudflare, paso a paso ────────────────────────────────────────────────
  cloudflare: {
    titulo: "Jak to zrobić w Cloudflare",
    subtitulo: "Dziesięć minut. Proszę mieć pod ręką e-mail i hasło do Cloudflare.",

    pasos: {
      uno: "Proszę zalogować się na dash.cloudflare.com na swoje konto.",
      dos: "Na pierwszym ekranie widać listę domen. Proszę kliknąć {dominio}.",
      tres: "W menu po lewej proszę otworzyć „DNS”, a następnie „Records”.",
      cuatro:
        "Pojawi się lista z liniami, które już istnieją. Proszę kliknąć przycisk „Add record”.",
      cinco: "W polu „Type” proszę wybrać z listy {tipo}.",
      seis: "W polu „Name” proszę wpisać {nombre}",
      siete: "W polu „Target” proszę wkleić {valor}",
      ocho:
        "W polu „Proxy status” proszę kliknąć pomarańczową chmurkę. Musi zmienić się na szarą i pokazywać „DNS only”.",
      nueve: "Pole „TTL” proszę zostawić na „Auto”. Nie ruszamy go.",
      diez: "Proszę kliknąć „Save”.",
      once:
        "Jeśli powyższa tabela ma więcej niż jedną linię, proszę powtórzyć od kroku 4 dla następnej.",
    },

    hecho: "To wszystko. Proszę wrócić do WACheckin i kliknąć „Sprawdź”.",

    avisoAntes: {
      titulo: "Zanim Pan/Pani zapisze, proszę to przeczytać",
      texto:
        "Cloudflare sam zmienia tę chmurkę na pomarańczową, bez pytania. Jeśli zostanie pomarańczowa, połączenie nie zadziała. Krok 8 jest na tym ekranie najważniejszy.",
    },

    accesoNegado: {
      titulo: "Nie może się Pan/Pani dostać do Cloudflare?",
      texto:
        "Konto zwykle należy do osoby, która stworzyła stronę. Proszę poprosić ją o wykonanie tych kroków albo o dodanie Pana/Pani jako członka domeny.",
    },
  },

  // ── La nube naranja ────────────────────────────────────────────────────────
  proxy: {
    titulo: "Pomarańczowa chmurka: to właśnie tu zawsze coś się psuje",
    queEs:
      "Obok każdej linii DNS Cloudflare pokazuje małą chmurkę. Pomarańczowa oznacza, że ruch idzie najpierw przez Cloudflare. Szara oznacza, że idzie prosto.",
    porQueFalla:
      "Przy pomarańczowej chmurce, gdy ktoś pyta o Pana/Pani domenę, Cloudflare nie odpowiada {destino}: odpowiada własnymi adresami. Nasze sprawdzenie pyta, dostaje Cloudflare i nie znajduje wpisu, o który pytało. Nawet jeśli wpisał(a) go Pan/Pani poprawnie, dla nas jest tak, jakby nie istniał.",
    porQueFalla2:
      "Jest też druga, gorsza konsekwencja: kłódka bezpieczeństwa dla strony jest wydawana po sprawdzeniu, czy domena prowadzi do nas. Przy pomarańczowej chmurce tak nie jest, więc kłódki nie da się wydać, a przeglądarka ostrzeże, że strona nie jest bezpieczna.",
    comoSeArregla:
      "Proszę kliknąć chmurkę. Zmieni się na szarą, a napis obok zmieni się na „DNS only”. Proszę zapisać. To wszystko.",
    grisEsSeguro:
      "Zmiana na szarą nie zostawia strony bez ochrony. Serwujemy stronę sami, z jej certyfikatem i za własnym zabezpieczeniem. Cloudflare był pośrodku tylko dlatego, że tak jest ustawiony domyślnie.",
    ttlBloqueado:
      "Szczegół, który wielu myli: dopóki chmurka jest pomarańczowa, Cloudflare nie pozwala ruszyć TTL. Zmiana na szarą odblokowuje to pole. Proszę zostawić je na „Auto”.",
    etiquetaProxied: "Proxied: pomarańczowa chmurka, NIE",
    etiquetaSoloDns: "DNS only: szara chmurka, TAK",
  },

  // ── El dominio corto (raíz) ────────────────────────────────────────────────
  raiz: {
    titulo: "Jeśli używa Pan/Pani krótkiej domeny: nie trzeba robić nic szczególnego",
    texto:
      "Istnieje stara zasada internetu mówiąca, że krótka domena ({dominio}, bez niczego z przodu) nie przyjmuje tego rodzaju wpisu. W większości firm zmusza to do obchodzenia problemu naokoło.",
    flattening:
      "Cloudflare rozwiązuje to sam. Gdy w polu „Name” jest @, stosuje własny mechanizm o nazwie CNAME flattening: zapisuje Pana/Pani przekierowanie, a gdy ktoś pyta, odpowiada od razu adresem docelowym. Nie trzeba niczego włączać, jest dostępny w każdym planie, także darmowym.",
    avisoAjusteGlobal:
      "Na co uważać: proszę nie ruszać opcji „CNAME flattening for all CNAME records” w „DNS” → „Settings”. Zastosowana do wszystkiego sprawia, że przekierowania przestają być zwracane tak, jak zostały zapisane, i psuje potwierdzanie własności w innych usługach, które Pan/Pani ma: poczcie, Google, sklepie…",
    tituloOtro: "Jeśli używa Pan/Pani krótkiej domeny ({dominio})",
    textoOtroA:
      "Domena bez niczego z przodu przyjmuje linie typu A, czyli te z tabeli. Każda firma je akceptuje.",
    textoOtroCname:
      "Wiele firm nie pozwala na CNAME dla domeny bez niczego z przodu. Jeśli Pana/Pani panel nie da zapisać tej linii, proszę użyć „www” albo osobnego adresu, na przykład rezerwacje.{dominio}, albo napisać do nas, a rozwiążemy to razem.",
    conflicto: {
      titulo: "Jeśli krótka domena miała już coś ustawione",
      texto:
        "Jedna nazwa nie może mieć naraz dwóch celów. Jeśli na liście jest już linia typu A lub CNAME z polem „Name” ustawionym na @ (albo na „www”, jeśli ma Pan/Pani używać www), proszę usunąć ją przed dodaniem naszej. Cloudflare ostrzeże, jeśli tego nie zrobimy.",
      textoOtro:
        "Jedna nazwa nie może mieć naraz dwóch celów. Jeśli w panelu jest już linia typu A lub CNAME o tej samej nazwie, proszę usunąć ją przed dodaniem naszej.",
      comoBorrar:
        "Proszę najechać na tę linię, kliknąć „Edit”, a potem „Delete”.",
      apunta:
        "Przed usunięciem warto zapisać na kartce, co w niej było, na wypadek powrotu do poprzedniego ustawienia.",
    },
  },

  // ── Cuánto tarda ───────────────────────────────────────────────────────────
  propagacion: {
    titulo: "Ile czasu minie, zanim strona się pokaże?",
    texto:
      "Cloudflare publikuje zmianę od razu. Czasu wymaga to, żeby dowiedziała się o niej reszta internetu: każdy komputer trzyma przez chwilę kopię zeszytu, żeby nie pytać tysiąc razy.",
    plazoNormal:
      "Przy TTL na „Auto” Cloudflare prosi, aby ta kopia żyła pięć minut. W praktyce zwykle działa po pięciu do trzydziestu minut od zapisania.",
    textoOtro:
      "Panel publikuje zmianę w ciągu kilku minut. Czasu wymaga to, żeby dowiedziała się o niej reszta internetu: każdy komputer trzyma przez chwilę kopię zeszytu, żeby nie pytać tysiąc razy.",
    plazoNormalOtro:
      "Zwykle działa po dziesięciu minutach do godziny od zapisania. Niektóre firmy publikują zmianę dłużej: proszę dać temu do 24 godzin, zanim zacznie się Pan/Pani martwić.",
    plazoMalo:
      "Jeśli domena pokazywała wcześniej inną stronę, Pana/Pani własny komputer może dłużej trzymać się tego, co zapamiętał. To nie jest usterka. Proszę dać temu 24 godziny, zanim zacznie się Pan/Pani martwić.",
    truco:
      "Sztuczka, żeby nie zwariować od sprawdzania: proszę otworzyć stronę w oknie prywatnym albo w telefonie na danych komórkowych zamiast na wifi. Wtedy widać to, co widzi nowy odwiedzający, a nie to, co zapamiętał Pana/Pani komputer.",
    dominioNuevo:
      "Jeszcze jedno: jeśli dopiero co dodał(a) Pan/Pani domenę do Cloudflare po raz pierwszy, Cloudflare potrzebuje do 24 godzin, żeby oznaczyć ją jako aktywną. Do tego czasu wszystko zachowuje się tak, jakby chmurki były szare, nawet jeśli widać je na pomarańczowo. Proszę poczekać, aż domena będzie miała status „Active”, zanim uzna się, że coś jest nie tak.",
    ssl:
      "Gdy sprawdzenie się powiedzie, wydajemy kłódkę bezpieczeństwa. To trwa jeszcze kilka minut. Do tego czasu przeglądarka może ostrzegać, że strona nie jest bezpieczna: to normalne i mija samo.",
  },

  // ── Paso 3: comprobar ──────────────────────────────────────────────────────
  paso3: {
    titulo: "Sprawdźmy to",
    descripcion:
      "Sprawdzamy Pana/Pani domenę i mówimy, co znaleźliśmy. Jeśli czegoś brakuje, napiszemy czego i jak to poprawić.",
    boton: "Sprawdź teraz",
    botonReintentar: "Sprawdź ponownie",
    comprobando: "Sprawdzamy wpisy…",
    comprobandoAyuda: "To potrwa kilka sekund.",

    resultado: {
      registroOk: "Wpis DNS jest na miejscu i prowadzi do nas",
      registroKo: "Nie widzimy jeszcze tego wpisu",
      proxyOk: "Chmurka jest szara, dokładnie tak, jak powinna",
      proxyKo: "Chmurka jest pomarańczowa",
      sslOk: "Kłódka bezpieczeństwa wydana",
      sslPendiente: "Wydawanie kłódki bezpieczeństwa…",
      webOk: "Strona otwiera się pod adresem {dominio}, z kłódką",
      webActivando: "Włączamy Pana/Pani stronę na tej domenie, razem z kłódką bezpieczeństwa",
      webDespues: "Następnie sprawdzamy, czy strona się otwiera, z kłódką",
    },

    activando: {
      titulo: "Domena prowadzi poprawnie. Włączamy stronę",
      texto:
        "Została tylko kłódka bezpieczeństwa, wydaje się automatycznie i zwykle trwa minutę lub dwie. Proszę niczego nie zmieniać w {panel}: sprawdzamy to, a gdy będzie gotowe, zobaczy to Pan/Pani tutaj.",
    },

    exito: {
      titulo: "Gotowe, strona jest już pod adresem {dominio}",
      texto:
        "Można wpisać ten adres w przeglądarce i ją zobaczyć. Stary adres {actual} nadal działa, więc linki, które już Pan/Pani udostępnił(a), nie przestaną działać.",
      verWeb: "Zobacz moją stronę",
      soloWww: "Twoja strona otwiera się pod adresem z «www». Jeśli chcesz, aby działała także bez «www», poproś dostawcę domeny o przekierowanie na adres z «www» albo o rekord ALIAS/ANAME w katalogu głównym, jeśli jego panel na to pozwala.",
      copiarEnlace: "Kopiuj adres",
      siguiente: "Teraz warto umieścić go w profilach na Booking.com, Airbnb i Instagramie oraz w stopce e-maila.",
    },

    pendiente: {
      titulo: "Jeszcze nie działa i to normalne",
      texto:
        "Jeśli dopiero co zapisał(a) to Pan/Pani w {panel}, proszę dać temu kilka minut i kliknąć ponownie. Nie trzeba tu czekać: wyślemy e-mail, gdy tylko będzie gotowe.",
      avisarme: "Powiadom mnie e-mailem, gdy będzie gotowe",
    },
  },

  // ── Estados del dominio en la ficha ────────────────────────────────────────
  estados: {
    sinConectar: "Niepodłączona",
    pendiente: "Czeka na wpisy",
    comprobando: "Sprawdzanie",
    emitiendoSsl: "Wydawanie kłódki",
    activo: "Działa",
    error: "Z usterką",
    activoAyuda: "Strona jest pod adresem {dominio}, a połączenie jest bezpieczne.",
    activandoAyuda: "Domena prowadzi poprawnie. Za kilka minut strona otworzy się pod adresem {dominio}, z kłódką.",
  },

  // ── Errores ────────────────────────────────────────────────────────────────
  errores: {
    formatoInvalido: {
      titulo: "To nie wygląda na domenę",
      texto: "Proszę wpisać ją tak: mojadomena.pl. Bez spacji i bez niczego więcej.",
    },
    conProtocolo: {
      titulo: "„https://” nie jest potrzebne",
      texto: "Proszę to usunąć i zostawić samą nazwę: {dominio}",
    },
    conRuta: {
      titulo: "Wszystko po ukośniku jest zbędne",
      texto: "Proszę zostawić tylko pierwszą część: {dominio}",
    },
    sinExtension: {
      titulo: "Brakuje końcówki",
      texto: "Domena kończy się na .pl, .com, .eu… Proszę sprawdzić, czy nie została ucięta.",
    },
    dominioNoExiste: {
      titulo: "Taka domena nie istnieje",
      texto:
        "Nikt nie jest zarejestrowany pod tą nazwą. Proszę sprawdzić pisownię. Jeśli dopiero co ją Pan/Pani kupił(a), proszę odczekać kilka godzin i spróbować ponownie.",
    },
    dominioCaducado: {
      titulo: "Ta domena wygląda na wygasłą",
      texto:
        "Proszę wejść do firmy, w której została kupiona, i sprawdzić, czy odnowienie jest opłacone. Dopóki jest wygasła, nie można jej podłączyć.",
    },
    yaUsadoOtraCuenta: {
      titulo: "Ta domena jest już podłączona do innego konta",
      texto:
        "Domena może prowadzić tylko w jedno miejsce naraz. Jeśli {dominio} należy do Pana/Pani, proszę napisać do nas, a odłączymy ją od tamtego konta, żeby można było użyć jej tutaj.",
      contactar: "Napisz do wsparcia",
    },
    yaUsadoEstaCuenta: {
      titulo: "Ta domena jest już podłączona",
      texto:
        "{dominio} jest używana w „{sitio}”. Proszę odłączyć ją tam albo wybrać inny adres dla tej strony.",
    },
    registrosNoAparecen: {
      titulo: "Nadal niczego nie widzimy na tej domenie",
      texto:
        "Zwykle to kwestia minut: zapis jest świeży i nie dotarł jeszcze wszędzie. Proszę odczekać dziesięć minut i kliknąć „Sprawdź” ponownie.",
      repasa: "Jeśli minęło pół godziny, proszę sprawdzić trzy rzeczy w {panel}:",
      repasa1: "Czy w polu „Nazwa” wpisał(a) Pan/Pani {nombre}, a nie całą domenę.",
      repasa2: "Czy kliknął(-ęła) Pan/Pani „Zapisz” i linia pojawiła się na liście.",
      repasa3: "Czy wpisał(a) to Pan/Pani na {dominio}, a nie na innej domenie na koncie.",
    },
    proxyActivado: {
      titulo: "Pomarańczowa chmurka jest włączona",
      texto:
        "Widzimy Pana/Pani domenę, ale przechodzi ona przez proxy Cloudflare, a to ukrywa przed nami prawdziwy cel. Dopóki pozostaje pomarańczowa, nie zadziała ani sprawdzenie, ani kłódka bezpieczeństwa.",
      solucion:
        "Proszę wejść w „DNS” → „Records”, znaleźć linię o nazwie {nombre}, klikać pomarańczową chmurkę, aż zmieni się na szarą z napisem „DNS only”, i zapisać. Potem proszę wrócić i kliknąć „Sprawdź”.",
    },
    apuntaOtroSitio: {
      titulo: "Domena prowadzi gdzie indziej",
      texto:
        "Znaleźliśmy {encontrado}, a spodziewaliśmy się {destino}. Prawie zawsze to stary wpis po poprzedniej stronie, który został.",
      solucion:
        "W „DNS” → „Records” proszę usunąć starą linię o nazwie {nombre} i zostawić tylko naszą.",
    },
    destinoAntiguo: {
      titulo: "Wartość, którą wcześniej podaliśmy, nie zadziałała",
      texto:
        "Wpis prowadzi do {encontrado}, czyli tam, gdzie kazaliśmy, ale ten adres nie działa. Błąd jest po naszej stronie, nie po Pana/Pani.",
      solucion: "W {panel} proszę edytować wpis {nombre} i ustawić wartość na {destino}. TXT proszę zostawić bez zmian.",
    },
    registroDuplicado: {
      titulo: "Są dwa wpisy o tej samej nazwie",
      texto:
        "Jedna nazwa nie może prowadzić w dwa miejsca. Proszę usunąć ten, który nie jest nasz, i sprawdzić ponownie.",
    },
    error1014: {
      titulo: "Jeśli przeglądarka pokazuje „Error 1014”",
      texto:
        "To kolejna twarz tego samego starego problemu: pomarańczowej chmurki. Proszę zmienić ją na szarą („DNS only”), a zniknie.",
    },
    sslFallido: {
      titulo: "Nie udało się wydać kłódki bezpieczeństwa",
      texto:
        "Wpis DNS jest poprawny, ale kłódka nie przechodzi. Zwykle to znowu pomarańczowa chmurka albo stary wpis, który przeszkadza. Proszę spróbować za chwilę; jeśli nic się nie zmieni, proszę napisać do nas, a sprawdzimy to.",
      reintentar: "Spróbuj wydać ponownie",
    },
    sinPermisos: {
      titulo: "Nie może Pan/Pani zmieniać domeny",
      texto: "Proszę poprosić o to właściciela konta.",
    },
    servidor: {
      titulo: "Nie udało się tego teraz sprawdzić",
      texto: "Coś zawiodło po naszej stronie. Proszę spróbować za kilka minut.",
    },
    guardar: "Nie udało się zapisać domeny. Proszę spróbować ponownie.",
  },

  // ── Desconectar ────────────────────────────────────────────────────────────
  desconectar: {
    boton: "Odłącz tę domenę",
    titulo: "Odłączyć {dominio}?",
    texto:
      "Strona przestanie pokazywać się pod adresem {dominio} i wróci do pokazywania się tylko pod {actual}. Kto wpisze Pana/Pani domenę, nie znajdzie nic, dopóki nie skieruje jej Pan/Pani gdzie indziej.",
    aviso: "Wpisy utworzone w {panel} nadal tam są. Proszę usunąć je samodzielnie, jeśli nie są już potrzebne.",
    cancelar: "Anuluj",
    confirmar: "Odłącz",
    hecho: "Domena odłączona.",
  },

  // ── Dudas ──────────────────────────────────────────────────────────────────
  dudas: {
    titulo: "Pytania, które pojawiają się zawsze",

    correoPregunta: "Czy to zepsuje moją pocztę @{dominio}?",
    correoTexto:
      "Nie. Poczta chodzi po innych liniach zeszytu, tych typu MX, a my ich nie ruszamy. Dopóki Pan/Pani ich nie usunie, poczta działa bez zmian.",

    otraWebPregunta: "Mam na tej domenie inną stronę. Co się z nią stanie?",
    otraWebTexto:
      "Przestanie się pokazywać: domena przełączy się na tę. Jeśli chce Pan/Pani zachować obie, proszę użyć dla strony WACheckin osobnego adresu, na przykład rezerwacje.{dominio}.",

    volverAtrasPregunta: "Czy mogę to cofnąć?",
    volverAtrasTexto:
      "Tak, kiedy tylko Pan/Pani zechce. Cofa się to tam, gdzie się to zrobiło: proszę usunąć wpis w {panel} i przywrócić ten, który był wcześniej. Pokazanie się zajmie tyle samo minut.",

    wwwPregunta: "Czy zadziała z „www” i bez niego?",
    wwwTexto:
      "Tak, jeśli doda Pan/Pani obie linie, które podajemy. Jedna prowadzi, a druga przekierowuje do pierwszej, żeby Google nie widział dwóch identycznych stron.",

    costePregunta: "Czy to coś kosztuje?",
    costeTexto:
      "Podłączenie nie. Za samą domenę płaci Pan/Pani tam, gdzie została kupiona, dokładnie jak wcześniej.",

    quienPregunta: "Nie czuję się na siłach, żeby to zrobić.",
    quienTexto:
      "To zrozumiałe, to najbardziej sucha część całego procesu. Proszę napisać do nas, podając domenę, a zrobimy to razem przez telefon w dziesięć minut.",
  },

  // ── Botonera ───────────────────────────────────────────────────────────────
  botones: {
    atras: "Wstecz",
    siguiente: "Dalej",
    guardar: "Zapisz",
    guardando: "Zapisywanie…",
    cerrar: "Zamknij",
    entendido: "Rozumiem",
    abrirCloudflare: "Otwórz Cloudflare",
    soporte: "Poproś o pomoc WACheckin",
    verGuia: "Zobacz przewodnik ponownie",
  },

  avisos: {
    copiado: "Skopiowano do schowka",
    copiadoError: "Nie udało się skopiować. Proszę zaznaczyć ręcznie.",
    guardado: "Domena zapisana. Teraz proszę dodać wpisy w {panel}.",
    conectado: "Strona jest już pod adresem {dominio}!",
    correoEnviado: "Wysłaliśmy instrukcję na Pana/Pani adres e-mail.",
  },
};
